export default __webpack_public_path__ + "static/Intro_Typography-402780fb7e601cdd1c7ab1e0d9e642a3.svg";